import React from 'react';
import { Link } from 'react-router-dom';
import useSeo from '../hooks/useSeo';
import './Pages.css';

function ThankYou() {
  useSeo(
    'Thank You | Rev-Tech',
    'Thank you for contacting Rev-Tech. Your inquiry has been received and we will be in touch soon.',
    {
      ogTitle: 'Thank You | Rev-Tech',
      ogDescription: 'Thank you for contacting Rev-Tech. Your inquiry has been received and we will be in touch soon.',
      twitterTitle: 'Thank You | Rev-Tech',
      twitterDescription: 'Thank you for contacting Rev-Tech. Your inquiry has been received and we will be in touch soon.',
      canonical: 'https://www.rev-technology.com/thank-you'
    }
  );

  return (
    <div className="page">
      <section className="hero">
        <h1>Thank You!</h1>
        <p className="hero-copy">
          Your message has been sent successfully. A member of the Rev-Tech team will contact you soon.
        </p>
        <Link to="/" className="cta-button">
          Return Home
        </Link>
      </section>
    </div>
  );
}

export default ThankYou;
